import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BubbleChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bubble_chart"}/>
}
